var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showHeader)?_c('div',{staticClass:"page-header-wrapper"},[_c('div',{staticClass:"page-header"},[_c('h1',[_vm._t("page-title")],2),_vm._t("header-slot")],2),_c('p',{staticClass:"subtitle"},[_vm._t("page-subtitle")],2)]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }